import scss from 'scss';

export default class Steps {
    constructor() {
        this.dom = {
            $window: $(window),
            $steps: $('.steps'),
            $subStepsList: $('.sub-steps-list'),
            language: $('html').attr('lang')
        };

        if (this.dom.$steps.length) {
            this.init();
        }
    }

    init() {
        this.buildSteps();
    }

    buildSteps() {
        let $w = this.dom.$window;
        let totalSteps = 0;
        this.dom.$steps.find('.steps-category').each((index, step) => {
            totalSteps = totalSteps + (((index == 0 && this.dom.$subStepsList.length > 0) ? 1.4 : 1) * Math.max($(step).attr('data-total-steps'), 3));
        });
        this.dom.$steps.find('.steps-category').each((index, step) => {
            let $step = $(step);
            let $bullet = $step.find('.steps-bullet');
            let $width = (100 * ((index == 0 && this.dom.$subStepsList.length > 0) ? 1.4 : 1) * Math.max($step.attr('data-total-steps'), 3)) / totalSteps;
            let $height = $width;

            if ($w.width() >= parseInt(scss['$sm'])) {
                $step.css('height', `${$height}%`);
            } else {
                $step.css('width', `${$width}%`);
            }

            if ($step.hasClass('passed')) {
                if ($w.width() >= parseInt(scss['$sm'])) {
                    $bullet.css('height', '100%');
                } else {
                    $bullet.css('width', '100%');
                }
            } else if ($step.hasClass('current')) {
                let $subWidth = (100 * this.dom.$steps.attr('data-current')) / $step.attr('data-total-steps');
                let $subHeight = $subWidth * 1.1;
                if ($w.width() >= parseInt(scss['$sm'])) {
                    $bullet.css('height', `${$subHeight}%`);
                } else {
                    $bullet.css('width', `${$subWidth}%`);
                }
            }
        });
    }
}
